import React from "react";

export default function Example(props) {
  if (props.example) {
    // If the definition contains an example, return sub-bullet point
    return (
      <ul>
        <li>
          <b>EXAMPLE: </b> <i>"{props.example}"</i>
        </li>
      </ul>
    );
  } else {
    return null;
  }
}
